import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import ratios from 'Components/utils/ratios/ratios.utils';
import { Badge } from 'Components/frameworks/badge/Badge';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Image } from 'Components/frameworks/image/Image';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  children?: ReactNode;
  className?: string;
  imageUrl: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  isSmall?: boolean;
  label: string;
  onClick?: () => void;
  title: string;
  url?: string;
};
export const FlyerCard = ({
  children,
  className,
  imageUrl,
  isChecked = false,
  isDisabled = false,
  isSmall = false,
  label,
  onClick,
  title,
  url,
  ...rest
}: Props) => {
  return (
    <article
      {...rest}
      className={classnames(
        'rounded-12 bg-white shadow-sm transition-all duration-250 ease-in',
        className,
      )}
    >
      <DynamicLink
        className={classnames('relative isolate flex h-full flex-col justify-start', {
          'p-15': !isSmall,
          'p-10': isSmall,
        })}
        onClick={onClick}
        shallow
        tagname="div"
        url={isDisabled ? '' : url}
      >
        {isChecked && (
          <span className="absolute end-0 top-0 m-5">
            <Badge
              className="size-20 border-success bg-success text-white"
              iconName={ICONS.CHECK}
              variant="pill"
            />
          </span>
        )}
        <div className="w-full shrink-0 self-center overflow-hidden rounded-full bg-grey">
          <Image
            className="h-full"
            imageUrl={imageUrl}
            ratioDisplay={1 / 4}
            ratioKey={ratios.SQUARE}
          />
        </div>
        <div className="basis-[20%]">
          <p className="text-12 font-bold text-sienna">{label}</p>
          <Title theme="title-sans-n3">
            <span className="overflow-wrap-break-word line-clamp-2">{title}</span>
          </Title>
        </div>
        {children}
      </DynamicLink>
    </article>
  );
};
